var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated-logo",class:{dark: _vm.$store.state.settings.darkMode}},[(!_vm.$store.state.settings.darkMode)?_c('img',{attrs:{"src":require("@/assets/suw.gif")}}):_c('img',{attrs:{"src":require("@/assets/logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }